import { createContext } from 'react';

const SupportModalContext = createContext({
	supportModalOpen: false,
	toggleSupportModal: () => {},
});

export default SupportModalContext;
